// extracted by mini-css-extract-plugin
export default {"title":"chat-rules_title__VMtO6","body":"chat-rules_body__0hFTM"};